import { createContext, useContext, useState } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../styles/toast.css'; // ← add this line, fix path if needed

type UIContextType = {
  showLoader: () => void;
  hideLoader: () => void;
  showSuccess: (msg: string) => void;
  showError: (msg: string) => void;
  showInfo: (msg: string) => void;
};

const UIContext = createContext<UIContextType>(null!);

export const useUI = () => useContext(UIContext);

export const UIProvider = ({ children }: { children: React.ReactNode }) => {
  const [loading, setLoading] = useState(false);

  return (
    <UIContext.Provider
      value={{
        showLoader: () => setLoading(true),
        hideLoader: () => setLoading(false),
        showSuccess: (msg) => toast.success(msg),
        showError: (msg) => toast.error(msg),
        showInfo: (msg) => toast.info(msg),
      }}
    >
      {children}

      <ToastContainer
        position="top-right"
        autoClose={2500}
        newestOnTop
        closeOnClick
        pauseOnHover
      />

      {loading && (
        <div className="global-loader">
          <ProgressSpinner
            style={{ width: '60px', height: '60px' }}
            strokeWidth="4"
          />
        </div>
      )}
    </UIContext.Provider>
  );
};
